module.exports = "/static-assets/_next/static/images/paper-note-combined-f92e39864c49f84fa3a1fe18a0f6a770.png";